// modelCache.js
const modelCache = {
    logoModel: null,
    treeModel: null,
    isLoaded: false
};

export default modelCache;